<template>
  <v-menu
      v-model="menu"
      offset-y
      :min-width="minWidth"
      :max-width="maxWidth"
      :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <div v-on="disabled ? ()=>{} : on ">
        <TextField
            theme="3"
            class="picker-field"
            :clearable="true"
            :readonly="true"
            :disabled="disabled"
            :label="label"
            min-width="235px"
            max-width="235px"
            :value="value"
            :rules="rules"
            @onClear="eventClear"
        ></TextField>
      </div>
    </template>
    <v-time-picker
        color="var(--theme-color-one)"
        :disabled="disabled"
        format="24hr"
        :value="value"
        @input="eventInput"
    ></v-time-picker>
  </v-menu>
</template>

<script>
import TextField from "./TextField"

export default {
  name: "DatePicker",
  components: {
    TextField
  },
  props: {
    rules: {
      type: Array,
      default: () => [],
    },
    value: {
      default: undefined
    },
    label: {
      default: ''
    },
    disabled:{
      default: false
    },
    minWidth: {
      default: 'auto'
    },
    maxWidth: {
      default: 'auto'
    },
  },
  data () {
    return {
      menu: false
    }
  },
  methods: {
    eventInput (val) {
      this.$emit('onInput', val)
    },
    eventClear () {
      this.$emit('onClear')
    }
  }
}
</script>

<style scoped>

</style>